module.exports = __webpack_public_path__ + "NG.png?162d3246e31513549c1d5bcd367db8f7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/NG.png
// module id = 388
// module chunks = 0